import React from 'react';
import {twMerge} from 'tailwind-merge';

import {getLocalizedStrings} from '../../../services/localization/localizationService';
import {ErrorIcon, WarningIcon} from '../../Icons';
import {MaxWidthContainer} from '../../Layout';

const Alert = (props) => {
    const {titleKey, description, descriptionKey, error, warning, className} = props;
    const localizedStrings = getLocalizedStrings();
    const Icon = getIcon({error, warning});

    return (
        <MaxWidthContainer
            className={twMerge('mb-8 mt-10 rounded bg-secondary p-8 lg:mb-[60px] lg:mt-[60px]', className)}
        >
            {Icon && <Icon className='mb-4 h-6 w-6 lg:mb-6 lg:h-8 lg:w-8' />}
            {titleKey && <h4>{localizedStrings[titleKey]}</h4>}
            {(description || descriptionKey) && (
                <p
                    dangerouslySetInnerHTML={{
                        __html: description || localizedStrings[descriptionKey],
                    }}
                />
            )}
        </MaxWidthContainer>
    );
};

export default Alert;

const getIcon = ({error, warning}) => {
    if (error) {
        return ErrorIcon;
    }
    if (warning) {
        return WarningIcon;
    }

    return null;
};
